import React from 'react';
import cn from 'classnames';

import styles from './traveler-profile-list.module.css';
import Table, { type RowData } from '../../../components/table/Table';

type TravelerProfileListProps = {
  searchFailed: boolean,
  loading: boolean,
  tableData: Array<RowData>,
};

export const TravelerProfileList = ({
  searchFailed,
  loading,
  tableData,
}: TravelerProfileListProps) => {
  const headers = [
    { header: 'Traveler Key' },
    { header: 'Last Name' },
    { header: 'First Name' },
    { header: 'Email' },
    { header: 'Phone' },
  ];

  const noRowsMessage = 'No Traveler Profile Found';
  const errorMessage = searchFailed
    ? 'Failed to search traveler profiles'
    : undefined;

  return (
    <>
      <div className={cn(styles.tableContainer)}>
        <Table
          {...{
            headers,
            data: tableData,
            noRowsValue: noRowsMessage,
            message: errorMessage,
            loading,
          }}
        />
      </div>
    </>
  );
};
